module.exports = __webpack_public_path__ + "static/media/boomer-group.538cbf0a.png";